// /mnt/data/SocialLinks.jsx
import React from "react";
import {
  Box,
  Stack,
  IconButton,
  Tooltip,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import TelegramIcon from "@mui/icons-material/Telegram";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/X";
import LaunchIcon from "@mui/icons-material/Launch";

const CARD_BG = "#263238";
const BORDER_COLOR = "rgba(255,255,255,0.08)";
const TEXT_MUTED = "#B0BEC5";
const BINANCE_YELLOW = "#F0B90B";

// ألوان العلامات
const TELEGRAM = "#229ED9";
const INSTAGRAM = "#E4405F"; // لمسة أساسية، مع توهج خفيف
const X_TWITTER = "#EAEFF2"; // محايد فاتح

export default function SocialLinks() {
  return (
    <Card
      sx={{
        bgcolor: CARD_BG,
        borderRadius: 2,
        border: `1px solid ${BORDER_COLOR}`,
        boxShadow: "0 8px 24px rgba(0,0,0,0.35)",
        overflow: "hidden",
      }}
    >
      <CardContent sx={{ p: { xs: 2.5, md: 3 } }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
          <Typography
            variant="h6"
            sx={{ fontWeight: 800, color: "#FFFFFF", letterSpacing: 0.2 }}
          >
            Join Our Community
          </Typography>
          {/* لمسة صفراء صغيرة بجانب العنوان */}
          <Box
            sx={{
              height: 3,
              width: 22,
              borderRadius: 2,
              background: `linear-gradient(90deg, ${BINANCE_YELLOW}, rgba(240,185,11,0.25))`,
            }}
          />
        </Box>

        <Typography sx={{ mb: 1.5, color: TEXT_MUTED }}>
          Follow 1CryptoX for announcements, product updates, and market
          insights.
        </Typography>

        <Stack direction="row" spacing={1.25}>
          {/* Telegram */}
          <Tooltip title="Telegram">
            <IconButton
              href="https://t.me/One_CryptoX_Official"
              target="_blank"
              sx={{
                bgcolor: "rgba(34,158,217,0.10)",
                border: `1px solid rgba(34,158,217,0.35)`,
                "&:hover": {
                  bgcolor: "rgba(34,158,217,0.18)",
                  boxShadow: `0 0 0 2px rgba(240,185,11,0.18) inset`,
                },
              }}
            >
              <TelegramIcon
                sx={{
                  color: TELEGRAM,
                  filter: "drop-shadow(0 0 3px rgba(34,158,217,0.5))",
                }}
              />
            </IconButton>
          </Tooltip>

          {/* Instagram */}
          <Tooltip title="Instagram">
            <IconButton
              href="https://www.instagram.com/1cryptox?igsh=MXU3NnkwbTRuM3AxOQ=="
              target="_blank"
              sx={{
                position: "relative",
                bgcolor: "rgba(228,64,95,0.10)",
                border: `1px solid rgba(228,64,95,0.35)`,
                overflow: "hidden",
                "&::after": {
                  // لمسة تدرّج خفيفة داخل الزر
                  content: '""',
                  position: "absolute",
                  inset: 0,
                  background:
                    "radial-gradient(80% 80% at 70% 30%, rgba(240,185,11,0.18), transparent 60%)",
                  pointerEvents: "none",
                },
                "&:hover": {
                  bgcolor: "rgba(228,64,95,0.18)",
                  boxShadow: `0 0 0 2px rgba(240,185,11,0.18) inset`,
                },
              }}
            >
              <InstagramIcon
                sx={{
                  color: INSTAGRAM,
                  filter: "drop-shadow(0 0 3px rgba(228,64,95,0.5))",
                }}
              />
            </IconButton>
          </Tooltip>

          {/* X (Twitter) */}
          <Tooltip title="X (Twitter)">
            <IconButton
              href="https://x.com/One_CryptoX?t=pMJsPsJ0DgroSMWa_LLTbg&s=09"
              target="_blank"
              sx={{
                bgcolor: "rgba(255,255,255,0.06)",
                border: `1px solid rgba(255,255,255,0.18)`,
                "&:hover": {
                  bgcolor: "rgba(255,255,255,0.10)",
                  boxShadow: `0 0 0 2px rgba(240,185,11,0.18) inset`,
                },
              }}
            >
              <TwitterIcon
                sx={{
                  color: X_TWITTER,
                  filter: "drop-shadow(0 0 3px rgba(255,255,255,0.35))",
                }}
              />
            </IconButton>
          </Tooltip>

          {/* Blog / Announcements */}
          <Tooltip title="Blog / Announcements">
            <IconButton
              href="/blog"
              sx={{
                bgcolor: "rgba(240,185,11,0.10)",
                border: `1px solid rgba(240,185,11,0.35)`,
                "&:hover": {
                  bgcolor: "rgba(240,185,11,0.18)",
                  boxShadow: `0 0 0 2px rgba(240,185,11,0.22) inset`,
                },
              }}
            >
              <LaunchIcon sx={{ color: BINANCE_YELLOW }} />
            </IconButton>
          </Tooltip>
        </Stack>
      </CardContent>
    </Card>
  );
}
